export const pageStyle = 'overflow-auto bg-gradient-to-br from-yellow-200 to-amber-400 h-screen flex flex-row justify-center items-center '

export const buttonBaseStyle = 'font-bold p-2 rounded-md shadow-sm transition-all'

export const textboxStyle = 'py-2 px-3 rounded-md border border-slate-200'

export const rowStyle = 'flex flex-row justify-between items-center'

export const radioStyles = {
    fieldSet: 'block',
    label: 'inline-flex items-center',
    option: 'ml-2 text-gray-800'
}

export const cardBaseStyle = 'bg-slate-50 rounded-md px-4 py-3 shadow-lg flex flex-col gap-5'

export const favoriteColor = 'bg-red-300 shadow-lg'
export const selectedColor = 'bg-slate-400'
export const whitespaceColor = 'bg-slate-50'
export const interactableColors = {
    warning: 'bg-red-400 hover:bg-red-300',
    proceed: 'bg-blue-300 hover:bg-blue-200',
    confirm: 'bg-emerald-400 hover:bg-emerald-300',
    neutral: 'bg-slate-300 hover:bg-slate-200'
}

export const errorTextColor = 'text-red-500'

export const typography = {
    display: 'text-5xl font-serif font-semibold',
    heading: 'text-2xl font-bold',
    body: 'font-semibold',
    caption: 'text-sm font-semibold text-slate-500'
}

export const oneLine = 'whitespace-nowrap overflow-hidden overflow-ellipsis'